export const checkPathInApps = (path, applications) =>
  applications.find(item => item.appUrl === path)
